<template>
  <div v-for="(mappingFields, groupName) in groupedMappingFields" :key="groupName" :class="{ 'mpf-tree': !initial }">
    <div
      v-if="groupName == '0'"
      v-for="mappingField in mappingFields"
      class="mpf-row mpf-grid px-8 py-3 justify-content-center align-items-center"
    >
      <div class="flex flex-column">
        <flow-data-mapping-field
          :id="`mpf1-${mappingField.mapping_field_name}`"
          :value="mappingField.mapping_field_value_1"
          :micro-function="mappingField.micro_function_1"
          :is-default="mappingField.is_default.mapping_field_value_1 && mappingField.is_default.micro_function_1"
          @configure="this.$emit('configure', true, mappingField)"
        />
      </div>
      <div class="flex justify-content-center">
        <p class="text-base mx-2">{{ mappingField.mapping_field_name }}</p>
        <hover-icon icon="question-mark-circle" :title="mappingField.description" hover/>
      </div>
      <div class="flex flex-column">
        <flow-data-mapping-field
          :id="`mpf2-${mappingField.mapping_field_name}`"
          :value="mappingField.mapping_field_value_2"
          :micro-function="mappingField.micro_function_2"
          :is-default="mappingField.is_default.mapping_field_value_2 && mappingField.is_default.micro_function_2"
          @configure="this.$emit('configure', false, mappingField)"
        />
      </div>
    </div>
    <expander v-else :title="groupName" :key="groupName" animation="bounce">
      <template #content>
        <flow-data-mapping-group
          :grouped-mapping-fields="mappingFields"
          @configure="(isFirstSide, mappingField) => this.$emit('configure', isFirstSide, mappingField)"
        />
      </template>
    </expander>
  </div>
</template>

<script>
import Expander from '@/components/Dashboard/Expander';
import FlowDataMappingField from '@/Pages/Dashboard/Integrations/Flows/Partials/FlowDataMappingField';
import HoverIcon from '@/components/Shared/HoverIcon.vue';

export default {
  name: 'FlowDataMappingGroup',

  components: {
    HoverIcon,
    FlowDataMappingField,
    Expander,
  },

  emits: ['configure'],

  props: {
    initial: {
      type: Boolean,
      default: false,
    },
    groupedMappingFields: [Object, Array],
  },
};
</script>

<style lang="scss" scoped>
.mpf-tree {
  border-left: 2px solid #eee;
  padding-left: 1rem;
}

.mpf-grid {
  display: grid;
  grid-gap: 2rem;

  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media screen and (min-width: 992px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.mpf-row {
  &:not(:last-child) {
    border-bottom: 2px solid #eee;
  }

  .mpf-field {
    position: relative;
    border: 1px solid #ddd;
  }
}
</style>
